import { useEffect, useRef } from 'react';
import { __ } from '@wordpress/i18n';

import { tabController } from '../../Components/utils/functions';

import Settings from './Settings';
import Style from './Style';
import TDViewer from './TDViewer';

const Edit = props => {
	const { className, attributes, setAttributes, clientId, isSelected } = props;
	const { sourceType, model, modelLink, isTouchMove, isZoom, loadingType } = attributes;

	useEffect(() => { clientId && setAttributes({ cId: clientId.substring(0, 10) }); }, [clientId]); // Set & Update clientId to cId

	useEffect(() => tabController(), [isSelected]);

	const tdvb3DViewerBlock = useRef(null);

	const toggleAttr = (selector, condition, attribute, value) => {
		condition && selector?.setAttribute(attribute, value);
		!condition && selector?.removeAttribute(attribute, value);
	}

	useEffect(() => {
		tdvb3DViewerBlock.current.innerHTML = '';

		const reInitModel = document.createElement('model-viewer');
		toggleAttr(reInitModel, true, 'class', 'tdvbModel');
		toggleAttr(reInitModel, true, 'src', 'upload' === sourceType ? model?.url : modelLink);
		toggleAttr(reInitModel, true, 'alt', 'upload' === sourceType ? model?.title : '');
		toggleAttr(reInitModel, isTouchMove, 'camera-controls', '');
		toggleAttr(reInitModel, !isZoom, 'disable-zoom', '');
		toggleAttr(reInitModel, true, 'loading', loadingType);
		toggleAttr(reInitModel, true, 'auto-rotate', '');

		tdvb3DViewerBlock.current.appendChild(reInitModel);
	}, [sourceType, model, modelLink, isTouchMove, isZoom, loadingType]);

	return <>
		<Settings attributes={attributes} setAttributes={setAttributes} clientId={clientId} />

		<div className={className} id={`tdvb3DViewerBlock-${clientId}`}>
			<Style attributes={attributes} clientId={clientId} />

			{'upload' === sourceType && !model.url ? <p className='noModel'>{__('Please, upload Model or enter Model Link first!', 'model-viewer')}</p> : ''}

			<TDViewer attributes={attributes} ref={tdvb3DViewerBlock} />
		</div >
	</>;
};
export default Edit;